window.ttx = window.ttx || {};

/*
 * tx.requirejs 使用示例（完整）
 *
 * ========================
 * 0) 先说明："加载"的是什么？
 * ========================
 * 这里的 require/define 主要加载的是"模块导出值"（函数、对象、常量等）。
 * - 当走 defineInner/requireInner 时：从当前页面内存里的 moduleMap 取模块。
 * - 当走 loadModule/require(无 ttx.domain) 时：通过 businessContext / Scripts[domain] 去 req('./xxx')，
 *   通常对应打包后的 js 模块（由构建工具处理）。
 *
 * ======================================
 * 1) defineInner：定义命名模块（推荐）
 * ======================================
 * ttx.defineInner('math/add', [], function () {
 *   return function (a, b) { return a + b; };
 * });
 *
 * ========================================
 * 2) defineInner：定义带依赖的命名模块
 * ========================================
 * ttx.defineInner('math/sum3', ['math/add'], function (add) {
 *   return function (a, b, c) { return add(add(a, b), c); };
 * });
 *
 * ======================================
 * 3) defineInner：匿名模块（内部会自动命名）
 * ======================================
 * const anonName = ttx.defineInner(['math/add'], function (add) {
 *   return add(10, 20);
 * });
 * // anonName 形如：_@anon_1
 *
 * =====================================
 * 4) requireInner：同步加载单模块（字符串）
 * =====================================
 * const add = ttx.requireInner('math/add');
 * const total = add(1, 2);
 *
 * =========================================
 * 5) requireInner：异步风格加载多模块（数组）
 * =========================================
 * ttx.requireInner(['math/add', 'math/sum3'], function (add, sum3) {
 *   const a = add(2, 3);
 *   const b = sum3(1, 2, 3);
 * }, function (err) {
 *   console.error('requireInner error:', err);
 * });
 *
 * =================================================
 * 6) defineInner 支持 require / exports / module 注入
 * =================================================
 * ttx.defineInner('counter', ['require', 'exports', 'module'], function (require, exports, module) {
 *   exports.value = 1;
 *   module.exports.inc = function () { exports.value += 1; };
 * });
 *
 * const counter = ttx.requireInner('counter');
 * counter.inc();
 *
 * =========================================================
 * 7) registerBusinessContext + loadModule（无 ttx.domain 时）
 * =========================================================
 * // 例如在宿主里注册一个可用的 require 函数
 * ttx.registerBusinessContext(function (path) {
 *   // path 形如 './user/list'
 *   return window.someModuleLoader(path);
 * });
 *
 * ttx.loadModule('sale', ['user/list', 'user/detail'], function (list, detail) {
 *   // list/detail 为加载到的模块导出
 * }, function (err) {
 *   console.error('loadModule error:', err);
 * });
 *
 * ===========================================================
 * 8) require(domain,deps,cb,errback)：业务入口（推荐外部用）
 * ===========================================================
 * // 场景A：未设置 ttx.domain -> 内部走 loadModule
 * ttx.require('sale', ['user/list'], function (list) {
 *   // list 来自 businessContext 或 Scripts[sale]
 * }, function (err) {
 *   console.error(err);
 * });
 *
 * // 场景B：设置了 ttx.domain -> 内部走 requireInner + 前缀拼接
 * ttx.domain = 'sale/order';
 * ttx.defineInner('sale/order/list/view', [], function () {
 *   return { name: 'list-view' };
 * });
 * ttx.defineInner('sale/order/detail/view', [], function () {
 *   return { name: 'detail-view' };
 * });
 *
 * ttx.require('sale', ['list/view', '/detail/view'], function (listView, detailView) {
 *   // 依赖会转换为：
 *   // 'sale/order/list/view' 与 'sale/order/detail/view'
 * });
 *
 * ================================================
 * 9) define(domain,deps,callback)：对齐 demo 的 define 包装
 * ================================================
 * // 注意：此 define 在有 ttx.domain 时，会把 deps 做前缀拼接后再 defineInner
 * ttx.domain = 'sale/order';
 * ttx.define('sale', ['state/store'], function (store) {
 *   // 这里 callback 会在 load/resolve 时使用
 * });
 *
 * ==========================================
 * 10) config：配置 baseUrl / paths / waitSeconds
 * ==========================================
 * ttx.requirejs.config({
 *   baseUrl: '/api/platform',
 *   paths: {
 *     'ext/script': ['/scripts/ANTH/ANTH_common', '/scripts/ANTH/ANTH_page']
 *   },
 *   waitSeconds: 30
 * });
 *
 * // paths 支持数组作为 fallback（依次尝试，第一个成功即停止）
 *
 * =====================================================
 * 11) 最小可运行顺序示例（可直接照着执行）
 * =====================================================
 * // 第1步：定义基础模块
 * ttx.defineInner('demo/msg', [], function () {
 *   return function (name) { return 'hello ' + name; };
 * });
 *
 * // 第2步：定义依赖模块
 * ttx.defineInner('demo/app', ['demo/msg'], function (msg) {
 *   return {
 *     run: function () {
 *       return msg('ttx');
 *     }
 *   };
 * });
 *
 * // 第3步：同步加载并执行
 * const app = ttx.requireInner('demo/app');
 * const text = app.run();
 * // text === 'hello ttx'
 *
 * // 第4步：异步风格加载
 * ttx.requireInner(['demo/app'], function (app2) {
 *   console.log(app2.run()); // hello ttx
 * }, function (err) {
 *   console.error(err);
 * });
 */
ttx.requirejs = {};

(function () {
    // ========== 配置（对齐参考版 config） ==========
    var config = {
        baseUrl: '',
        paths: {},
        waitSeconds: 30,
        scriptPrefix: 'ext/script/',
        scriptCodePattern: 'AT[A-F0-9]{16}'
    };

    // 获取 paths 中脚本前缀对应的 key（去掉末尾 /）
    function getScriptPathKey() {
        return config.scriptPrefix.replace(/\/$/, '');
    }

    // ========== 模块注册表 ==========
    var moduleMap = {};
    var scriptUrlCache = {}; // scriptCode → 精确 URL 映射（由 loadPageScripts 注入）
    var anonSeed = 1;

    // ========== 工具函数 ==========
    function isArray(value) {
        return ttx.utils && typeof ttx.utils.isArray === 'function'
            ? ttx.utils.isArray(value)
            : Object.prototype.toString.call(value) === '[object Array]';
    }

    function isFunction(value) {
        return typeof value === 'function';
    }

    function hasProp(obj, prop) {
        return Object.prototype.hasOwnProperty.call(obj, prop);
    }

    function normalizeDeps(deps) {
        if (!isArray(deps)) return [];
        return deps.filter(function (name) {
            return typeof name === 'string' && name.trim();
        });
    }

    // ========== 路径标准化（对齐参考版 normalize/trimDots） ==========
    function trimDots(ary) {
        for (var i = 0; i < ary.length; i++) {
            var part = ary[i];
            if (part === '.') {
                ary.splice(i, 1);
                i -= 1;
            } else if (part === '..') {
                if (i === 0 || (i === 1 && ary[2] === '..') || ary[i - 1] === '..') {
                    continue;
                } else if (i > 0) {
                    ary.splice(i - 1, 2);
                    i -= 2;
                }
            }
        }
    }

    function normalize(name, baseName) {
        if (!name) return name;
        var baseParts = baseName && baseName.split('/');
        name = name.split('/');
        // 去掉末尾 .js
        var lastIndex = name.length - 1;
        if (/\.js$/.test(name[lastIndex])) {
            name[lastIndex] = name[lastIndex].replace(/\.js$/, '');
        }
        // 相对路径处理：'./foo' 或 '../foo'
        if (name[0].charAt(0) === '.' && baseParts) {
            var normalizedBaseParts = baseParts.slice(0, baseParts.length - 1);
            name = normalizedBaseParts.concat(name);
        }
        trimDots(name);
        name = name.join('/');
        return name;
    }

    // ========== nameToUrl：模块名 → URL（对齐参考版 nameToUrl） ==========
    function nameToUrl(moduleName) {
        // 如果已经是 URL 或绝对路径，直接返回
        if (/^\/|:|\?|\.js$|\.css$/.test(moduleName)) {
            return moduleName;
        }

        var paths = config.paths;
        var syms = moduleName.split('/');
        var parentModule, parentPath;

        // 从最长匹配查找 paths 映射
        for (var i = syms.length; i > 0; i -= 1) {
            parentModule = syms.slice(0, i).join('/');
            parentPath = paths[parentModule];
            if (parentPath) {
                if (isArray(parentPath)) {
                    parentPath = parentPath[0];
                }
                syms.splice(0, i, parentPath);
                break;
            }
        }

        var url = syms.join('/');
        url += '.js';
        url = (url.charAt(0) === '/' || /^[\w+-.]+:/.test(url) ? '' : config.baseUrl) + url;
        return url;
    }

    // ========== 获取 paths 中某模块前缀的所有备选路径（支持数组 fallback） ==========
    function getPathFallbacks(moduleName) {
        var paths = config.paths;
        var syms = moduleName.split('/');
        for (var i = syms.length; i > 0; i -= 1) {
            var parentModule = syms.slice(0, i).join('/');
            var parentPath = paths[parentModule];
            if (parentPath) {
                if (isArray(parentPath)) {
                    var suffix = syms.slice(i).join('/');
                    return parentPath.map(function (p) {
                        return p + '/' + suffix + '.js';
                    });
                }
                return [nameToUrl(moduleName)];
            }
        }
        return [nameToUrl(moduleName)];
    }

    function buildUrlWithPlatform(path) {
        var platform = (ttx.ajax && ttx.ajax.config && ttx.ajax.config().script) || '';
        if (path.indexOf('://') === -1 && path.charAt(0) !== '/') {
            return platform + path;
        }
        return path;
    }

    // ========== 模块事件系统（对齐参考版 Module.on/emit） ==========
    function emitModuleEvent(moduleName, eventName, data) {
        var record = moduleMap[moduleName];
        if (record && record._events && record._events[eventName]) {
            var cbs = record._events[eventName].slice();
            for (var i = 0; i < cbs.length; i++) {
                try {
                    cbs[i](data);
                } catch (e) {
                    if (ttx.requirejs.onError) {
                        ttx.requirejs.onError(e);
                    }
                }
            }
            // error 事件只触发一次
            if (eventName === 'error') {
                delete record._events[eventName];
            }
        }
    }

    function onModuleEvent(moduleName, eventName, callback) {
        var record = moduleMap[moduleName];
        if (!record) {
            // 创建占位记录（pending 状态，等待 defineInner 填充）
            record = moduleMap[moduleName] = {
                name: moduleName,
                deps: [],
                factory: null,
                exports: undefined,
                resolved: false,
                _pending: true,
                _events: {}
            };
        }
        if (!record._events) {
            record._events = {};
        }
        if (!record._events[eventName]) {
            record._events[eventName] = [];
        }
        record._events[eventName].push(callback);
    }

    // ========== 解析单个模块（支持 require/exports/module） ==========
    function resolveModule(name, stack) {
        var moduleName = (name || '').trim();
        if (!moduleName) {
            throw new Error('requirejs: module name is required');
        }

        if (stack.includes(moduleName)) {
            throw new Error('requirejs: circular dependency -> ' + stack.concat(moduleName).join(' -> '));
        }

        var record = moduleMap[moduleName];
        if (!record) {
            throw new Error('requirejs: module not found -> ' + moduleName);
        }

        if (record.resolved) {
            return record.exports;
        }

        var nextStack = stack.concat(moduleName);
        var moduleObj = { id: moduleName, exports: record.exports || {} };
        var exportsObj = moduleObj.exports;

        var depExports = record.deps.map(function (dep) {
            if (dep === 'require') return ttx.requireInner;
            if (dep === 'exports') return exportsObj;
            if (dep === 'module') return moduleObj;
            return resolveModule(dep, nextStack);
        });

        if (typeof record.factory === 'function') {
            var result = record.factory.apply(window, depExports);
            if (result !== undefined) {
                record.exports = result;
            } else if (moduleObj.exports !== exportsObj) {
                record.exports = moduleObj.exports;
            } else {
                record.exports = exportsObj;
            }
        } else if (record.factory !== null) {
            record.exports = record.factory;
        } else {
            record.exports = exportsObj;
        }

        record.resolved = true;

        // 触发 defined 事件（对齐参考版 emit('defined')）
        emitModuleEvent(moduleName, 'defined', record.exports);

        return record.exports;
    }

    // ========== defineInner ==========
    function defineInner(name, deps, callback) {
        var moduleName = name;
        var moduleDeps = deps;
        var moduleFactory = callback;

        if (typeof moduleName !== 'string') {
            moduleFactory = moduleDeps;
            moduleDeps = moduleName;
            moduleName = '_@anon_' + anonSeed++;
        }

        if (!isArray(moduleDeps)) {
            moduleFactory = moduleDeps;
            moduleDeps = [];
        }

        // 如果已有 pending 记录（由 onModuleEvent 创建的占位），更新它
        var existing = moduleMap[moduleName];
        if (existing && existing._pending) {
            existing.deps = normalizeDeps(moduleDeps);
            existing.factory = moduleFactory;
            existing._pending = false;
        } else {
            moduleMap[moduleName] = {
                name: moduleName,
                deps: normalizeDeps(moduleDeps),
                factory: moduleFactory,
                exports: undefined,
                resolved: false
            };
        }

        return moduleName;
    }

    // ========== 异步脚本标签加载（对齐参考版 req.load） ==========
    function loadScript(url, moduleName, onLoad, onErr) {
        var node = document.createElement('script');
        node.type = 'text/javascript';
        node.charset = 'utf-8';
        node.async = true;
        node.setAttribute('data-requiremodule', moduleName);

        var done = false;
        function handleLoad() {
            if (done) return;
            done = true;
            node.onload = node.onerror = node.onreadystatechange = null;
            if (node.parentNode && node.parentNode !== document.head && node.parentNode !== document.documentElement) {
                // 保留标签以便 undef 清理
            }
            if (onLoad) onLoad();
        }
        function handleError() {
            if (done) return;
            done = true;
            node.onload = node.onerror = node.onreadystatechange = null;
            if (node.parentNode) node.parentNode.removeChild(node);
            if (onErr) onErr(new Error('Script load error: ' + url));
        }

        node.onload = handleLoad;
        node.onerror = handleError;

        if (node.readyState) {
            // IE
            node.onreadystatechange = function () {
                if (node.readyState === 'loaded' || node.readyState === 'complete') {
                    handleLoad();
                }
            };
        }

        node.src = url;
        document.head.appendChild(node);
    }

    // ========== loadExtScript：ext/script/* 同步懒加载（使用 paths 配置） ==========
    function loadExtScript(moduleName) {
        var scriptCode = moduleName.substring(config.scriptPrefix.length);
        var urls = getExtScriptUrls(scriptCode);

        for (var i = 0; i < urls.length; i++) {
            try {
                var xhr = new XMLHttpRequest();
                xhr.open('GET', urls[i], false);
                xhr.send();
                if (xhr.status !== 200) {
                    ttx.log && ttx.log.warn('[ttx.requirejs] loadExtScript: HTTP ' + xhr.status + ' from ' + urls[i]);
                    continue;
                }
                if (!xhr.responseText) {
                    ttx.log && ttx.log.warn('[ttx.requirejs] loadExtScript: empty response from ' + urls[i]);
                    continue;
                }
                var content = xhr.responseText.trim();
                // 校验：跳过明显的非 JS 内容（JSON 响应、HTML 页面等）
                var firstChar = content.charAt(0);
                if (!content || firstChar === '{' || firstChar === '<') {
                    ttx.log && ttx.log.warn('[ttx.requirejs] loadExtScript: invalid content from ' + urls[i] +
                        ' (starts with "' + firstChar + '"), skipped');
                    continue;
                }
                // 校验：内容中应包含 defineInner 注册调用
                if (content.indexOf('defineInner') === -1 && content.indexOf('ttx.defineInner') === -1) {
                    ttx.log && ttx.log.warn('[ttx.requirejs] loadExtScript: content from ' + urls[i] +
                        ' does not contain defineInner, skipped. first 200 chars: ' + content.substring(0, 200));
                    continue;
                }
                // 如果内容中 defineInner 是匿名的（后端 writeToFile 未注入模块名），补上模块名
                if (content.indexOf(moduleName) === -1) {
                    content = content.replace(
                        /(ttx\.defineInner\s*\(\s*)\[\s*\]/,
                        '$1"' + moduleName + '", []'
                    );
                }
                try {
                    var el = document.createElement('script');
                    el.textContent = content;
                    document.head.appendChild(el);
                } catch (scriptErr) {
                    ttx.log && ttx.log.warn('[ttx.requirejs] loadExtScript: script execution failed from ' + urls[i] +
                        ': ' + scriptErr.message);
                    continue;
                }
                if (moduleMap[moduleName]) {
                    ttx.log && ttx.log.info('[ttx.requirejs] loadExtScript: loaded ' + moduleName + ' from ' + urls[i]);
                    return;
                }
                // 内容执行了但模块未注册（defineInner 可能用了不同的名称）
                ttx.log && ttx.log.warn('[ttx.requirejs] loadExtScript: script executed from ' + urls[i] +
                    ' but module ' + moduleName + ' not registered. content preview: ' + content.substring(0, 300));
            } catch (e) {
                ttx.log && ttx.log.warn('[ttx.requirejs] loadExtScript: XHR error for ' + urls[i] + ': ' + (e && e.message));
            }
        }
    }

    // ========== loadExtScriptAsync：ext/script/* 异步懒加载（脚本标签方式） ==========
    function loadExtScriptAsync(moduleName, callback, errback) {
        var scriptCode = moduleName.substring(config.scriptPrefix.length);
        var urls = getExtScriptUrls(scriptCode);

        // 超时检测（对齐参考版 waitSeconds）
        var timeout;
        if (config.waitSeconds > 0) {
            timeout = setTimeout(function () {
                emitModuleEvent(moduleName, 'error',
                    new Error('Timeout loading module: ' + moduleName));
            }, config.waitSeconds * 1000);
        }

        var tried = 0;
        function tryNext() {
            if (tried >= urls.length) {
                if (timeout) clearTimeout(timeout);
                var err = new Error('Module not found: ' + moduleName + ', tried: ' + urls.join(', '));
                if (errback) {
                    errback(err);
                } else if (ttx.requirejs.onError) {
                    ttx.requirejs.onError(err);
                }
                return;
            }
            var url = urls[tried++];
            loadScript(url, moduleName, function () {
                // 脚本加载完成，检查模块是否已被 defineInner 注册
                var record = moduleMap[moduleName];
                if (record && !record._pending) {
                    if (timeout) clearTimeout(timeout);
                    if (callback) callback();
                } else {
                    // 模块未注册（脚本内容可能没有 defineInner），尝试下一个路径
                    tryNext();
                }
            }, function () {
                tryNext();
            });
        }
        tryNext();
    }

    // ========== 获取 ext/script/* 的请求URL列表 ==========
    function getExtScriptUrls(scriptCode) {
        // 优先使用 loadPageScripts 中缓存的精确路径（避免猜 common/page）
        if (scriptUrlCache[scriptCode]) {
            return [scriptUrlCache[scriptCode]];
        }
        var pathKey = getScriptPathKey();
        if (config.paths[pathKey]) {
            var pathVal = config.paths[pathKey];
            if (isArray(pathVal)) {
                return pathVal.map(function (p) {
                    return buildUrlWithPlatform(p) + '/' + scriptCode + '.js';
                });
            }
            return [buildUrlWithPlatform(pathVal) + '/' + scriptCode + '.js'];
        }
        // 默认路径（兼容未配置 paths 且无缓存的情况）
        var platform = (ttx.ajax && ttx.ajax.config && ttx.ajax.config().script) || '';
        return [
            platform + '/scripts/extend/AT_common/' + scriptCode + '.js',
            platform + '/scripts/extend/AT_page/' + scriptCode + '.js'
        ];
    }

    // ========== completeLoad（对齐参考版：处理脚本加载完成后的模块注册） ==========
    function completeLoad(moduleName) {
        var record = moduleMap[moduleName];
        if (!record || record._pending) {
            // 模块未被 define，创建空导出（对齐参考版 no-define 情况）
            if (!record) {
                moduleMap[moduleName] = {
                    name: moduleName,
                    deps: [],
                    factory: {},
                    exports: {},
                    resolved: true
                };
            } else {
                record.exports = {};
                record.resolved = true;
                record._pending = false;
            }
            emitModuleEvent(moduleName, 'defined', moduleMap[moduleName].exports);
        }
    }

    // ========== requireInner ==========
    function requireInner(deps, callback, errback) {
        try {
            // 字符串模式：同步访问（ext/script/* 未注册时尝试同步 XHR 加载）
            if (typeof deps === 'string') {
                if (deps.indexOf(config.scriptPrefix) === 0 && !moduleMap[deps]) {
                    loadExtScript(deps);
                }
                if (!moduleMap[deps]) {
                    var triedUrls = getExtScriptUrls(deps.substring(config.scriptPrefix.length));
                    throw new Error('requirejs: module not found -> ' + deps +
                        ' (tried: ' + triedUrls.join(', ') + ')');
                }
                var result = resolveModule(deps, []);
                if (typeof callback === 'function') {
                    callback.call(window, result);
                }
                return result;
            }

            // 数组模式：先同步加载未注册的 ext/script/* 模块，再解析
            var moduleDeps = normalizeDeps(deps);
            var depExports = moduleDeps.map(function (dep) {
                if (dep.indexOf(config.scriptPrefix) === 0 && !moduleMap[dep]) {
                    loadExtScript(dep);
                }
                if (!moduleMap[dep]) {
                    var triedUrls = getExtScriptUrls(dep.substring(config.scriptPrefix.length));
                    throw new Error('requirejs: module not found -> ' + dep +
                        ' (tried: ' + triedUrls.join(', ') + ')');
                }
                return resolveModule(dep, []);
            });
            if (typeof callback === 'function') {
                callback.apply(window, depExports);
            }
            return depExports;
        } catch (err) {
            if (typeof errback === 'function') {
                errback(err);
                return [];
            }
            if (ttx.requirejs.onError) {
                ttx.requirejs.onError(err);
                return [];
            }
            throw err;
        }
    }

    // ========== undef：取消模块定义（对齐参考版 undef） ==========
    function undef(moduleName) {
        var record = moduleMap[moduleName];
        delete moduleMap[moduleName];

        // 清理对应的 script 标签
        if (typeof document !== 'undefined') {
            var scripts = document.getElementsByTagName('script');
            for (var i = scripts.length - 1; i >= 0; i--) {
                if (scripts[i].getAttribute('data-requiremodule') === moduleName) {
                    scripts[i].parentNode.removeChild(scripts[i]);
                }
            }
        }
    }

    // ========== 业务上下文（对齐参考版 businessContext / registerBusinessContext） ==========
    ttx.requirejs.businessContext = null;
    ttx.requirejs.registerBusinessContext = function (ctx) {
        ttx.requirejs.businessContext = ctx;
    };

    // loadModule（对齐参考版 cb.utils.loadModule）
    ttx.requirejs.loadModule = function (domain, deps, callback, errback) {
        if (typeof domain === 'function') {
            domain();
            return;
        }

        if (isArray(domain)) {
            errback = arguments[2];
            callback = arguments[1];
            deps = arguments[0];
            domain = null;
        }

        if (!isArray(deps)) {
            if (typeof deps === 'function') deps();
            return;
        }

        var args = [];
        if (!domain) domain = ttx.loader && ttx.loader.domainKey;

        var req = (domain && ttx.extend && ttx.extend.Scripts && ttx.extend.Scripts[domain]) || ttx.requirejs.businessContext;

        if (!req) {
            var error = new Error('ttx.requirejs.loadModule: business context not initialized');
            if (typeof errback === 'function') {
                errback(error);
                return;
            }
            if (typeof callback === 'function') callback.apply(this, args);
            return;
        }

        try {
            deps.forEach(function (item) {
                args.push(req('./' + item));
            });
        } catch (error) {
            if (typeof errback === 'function') {
                errback(error);
            }
            return;
        }

        if (typeof callback === 'function') {
            callback.apply(this, args);
        }
    };

    // require（对齐参考版 cb.require）
    ttx.requirejs.require = function (domain, deps, callback, errback) {
        if (ttx.context && typeof ttx.context.getQuery === 'function') {
            var query = ttx.context.getQuery() || {};
            if (query.extend === 'false') {
                if (typeof errback === 'function') errback({ message: 'extend false' });
                return;
            }
        }

        if (!ttx.domain) {
            ttx.requirejs.loadModule(domain, deps, callback, errback);
            return;
        }

        var newDeps = deps;
        if (isArray(deps)) {
            newDeps = deps.map(function (item) {
                return ttx.domain + (item.substr(0, 1) === '/' ? '' : '/') + item;
            });
        }

        return requireInner(newDeps, callback, errback);
    };

    // define（对齐参考版 cb.define）
    ttx.requirejs.define = function (domain, deps, callback) {
        if (!ttx.domain) {
            ttx.requirejs.loadModule(domain, deps, callback);
            return;
        }

        var newDeps = deps;
        if (isArray(deps)) {
            newDeps = deps.map(function (item) {
                return ttx.domain + (item.substr(0, 1) === '/' ? '' : '/') + item;
            });
        }

        return defineInner(newDeps, callback);
    };

    // ========== 对外 API ==========

    // 核心方法
    ttx.requirejs.defineInner = defineInner;
    ttx.requirejs.requireInner = requireInner;

    // 配置（对齐参考版 config）
    ttx.requirejs.config = function (cfg) {
        if (!cfg) return;
        if (cfg.baseUrl) {
            if (cfg.baseUrl.charAt(cfg.baseUrl.length - 1) !== '/') {
                cfg.baseUrl += '/';
            }
            config.baseUrl = cfg.baseUrl;
        }
        if (cfg.paths) {
            for (var key in cfg.paths) {
                if (hasProp(cfg.paths, key)) {
                    config.paths[key] = cfg.paths[key];
                }
            }
        }
        if (cfg.waitSeconds != null) {
            config.waitSeconds = cfg.waitSeconds;
        }
        if (typeof cfg.scriptPrefix === 'string') {
            config.scriptPrefix = cfg.scriptPrefix;
        }
        if (typeof cfg.scriptCodePattern === 'string') {
            config.scriptCodePattern = cfg.scriptCodePattern;
        }
    };

    // 获取配置（只读）
    ttx.requirejs.getConfig = function () {
        return {
            baseUrl: config.baseUrl,
            paths: config.paths,
            waitSeconds: config.waitSeconds,
            scriptPrefix: config.scriptPrefix,
            scriptCodePattern: config.scriptCodePattern
        };
    };

    // 模块名→URL（对齐参考版 toUrl）
    ttx.requirejs.toUrl = function (moduleName) {
        return nameToUrl(moduleName);
    };
    ttx.requirejs.nameToUrl = ttx.requirejs.toUrl;

    // undef（对齐参考版）
    ttx.requirejs.undef = undef;

    // defined：检查模块是否已定义并解析（对齐参考版 defined）
    ttx.requirejs.defined = function (name) {
        var record = moduleMap[name];
        return !!(record && record.resolved);
    };

    // specified：检查模块是否已注册（对齐参考版 specified）
    ttx.requirejs.specified = function (name) {
        return !!moduleMap[name];
    };

    // normalize：标准化模块名（处理 ./ 和 ../）
    ttx.requirejs.normalize = function (name, baseName) {
        return normalize(name, baseName);
    };

    // has（保留旧 API 兼容）
    ttx.requirejs.has = ttx.requirejs.specified;

    // remove（保留旧 API）
    ttx.requirejs.remove = undef;

    // clear
    ttx.requirejs.clear = function () {
        Object.keys(moduleMap).forEach(function (name) {
            delete moduleMap[name];
        });
    };

    // 缓存脚本精确路径（由 loadPageScripts 调用，避免 loadExtScript 时猜路径）
    ttx.requirejs.cacheScriptUrl = function (scriptCode, url) {
        if (scriptCode && url) {
            scriptUrlCache[scriptCode] = url;
        }
    };

    // 清除脚本路径缓存
    ttx.requirejs.clearScriptUrlCache = function () {
        Object.keys(scriptUrlCache).forEach(function (key) {
            delete scriptUrlCache[key];
        });
    };

    // 异步加载 ext/script/* 模块（使用脚本标签方式，不阻塞主线程）
    ttx.requirejs.loadExtScriptAsync = loadExtScriptAsync;

    // 异步脚本标签加载工具（可复用于其他场景）
    ttx.requirejs.loadScript = loadScript;

    // completeLoad（脚本加载完成后通知模块已就绪）
    ttx.requirejs.completeLoad = completeLoad;

    // onError（对齐参考版 req.onError）：全局错误回调
    ttx.requirejs.onError = null;

    // ========== 对外别名（与参考版命名风格一致） ==========
    ttx.registerBusinessContext = ttx.requirejs.registerBusinessContext;
    ttx.loadModule = ttx.requirejs.loadModule;
    ttx.require = ttx.requirejs.require;
    ttx.define = ttx.requirejs.define;
    ttx.requireInner = ttx.requirejs.requireInner;
    ttx.defineInner = ttx.requirejs.defineInner;

    // 全局暴露（避免覆盖 React/Webpack/Vite 的 define/require）
    if (typeof window !== 'undefined') {
        window.requireInner = ttx.requireInner;
        window.defineInner = ttx.defineInner;
    }
})();
